import React, { useRef } from "react";
import PropTypes from "prop-types";
import {
  NestedFieldSet,
  FormGroupSelect,
  FormGroupInput,
} from "components/formElements";
import {
  getOptions,
  minYearOfCompletion,
  maxYearOfCompletion,
  minScore,
  maxScore,
  stepScore,
} from "util/library";
import {
  getCommonErrorMessage,
  getScoreErrorMessage,
  getYearOfCompletionErrorMessage,
} from "util/validations";
import Select from 'react-select';
import { getReactSelectOptions, CustomPlaceholder, customStyles } from "util/library";

const PostGraduation = ({
  handleChange,
  handlePostGradStreamChange,
  postGraduationStreams,
  postGraduationStream,
  postGraduationStreamName,
  postGraduationScore,
  postGraduationCollegeOrUniversity,
  postGraduationYear,
}) => {
  const postGradSelectRef = useRef(null);
  const inputRef = useRef(null);
  const yearOfCompletionRef = useRef(null);

  //const handleStreamChange = () => {
  //  const { options, selectedIndex, value } = postGradSelectRef.current;
  //  handlePostGradStreamChange(
  //    value,
  //    Number(value) === -1 ? "" : options[selectedIndex].text
  //  );
  //  };
    const handleStreamChange = (selected) => {
        const value = selected?.value ?? "";
        const label = Number(value) === -1 ? "" : selected?.label ?? "";
        handlePostGradStreamChange(value, label);
    };

  return (
    <NestedFieldSet legendText="Post Graduation">
      {/*<FormGroupSelect*/}
      {/*  selectRef={postGradSelectRef}*/}
      {/*  id="postGraduationStream"*/}
      {/*  name="postGraduationStream"*/}
      {/*  label="Stream"*/}
      {/*  value={postGraduationStream}*/}
      {/*  onChange={handleStreamChange}*/}
      {/*  options={getOptions(*/}
      {/*    postGraduationStreams,*/}
      {/*    "Select Post Graduation Stream"*/}
      {/*  )}*/}
      {/*    />*/}
              <Select
                  id="graduationStream"
                  name="graduationStream"
                  options={getReactSelectOptions(postGraduationStreams)} // assuming this formats like [{ value, label }]
                  value={getReactSelectOptions(postGraduationStreams).find(
                      (opt) => opt.value === postGraduationStream
                  )}
                  onChange={handleStreamChange}

              placeholder="Select Post Graduation Stream"
                  styles={customStyles}
                  isClearable={true}


              />
      {Number(postGraduationStream) === -1 && (
        <FormGroupInput
          type="text"
          id="postGraduationStreamName"
          name="postGraduationStreamName"
          label="Post Graduation Stream Name"
          //placeholder="Post Graduation Stream Name"
          value={postGraduationStreamName}
          onChange={handleChange}
          errorMessage={getCommonErrorMessage(
            postGraduationStreamName,
            "Post Graduation Stream",
            true
          )}
          required
          // eslint-disable-next-line no-useless-escape
          pattern={"[a-z|A-Z]{1}[a-z|A-Z|.]{1}(a-z|A-Z| |.)*"}
        />
      )}
      <FormGroupInput
        type="number"
        min={minScore}
        max={maxScore}
        step={stepScore}
        id="postGraduationScore"
        name="postGraduationScore"
        label="Score(%)"
        //placeholder="Score(%)"
        value={postGraduationScore}
        onChange={handleChange}
        inputRef={inputRef}
        errorMessage={getScoreErrorMessage(inputRef, postGraduationScore, true)}
      />
      <FormGroupInput
        type="text"
        id="postGraduationCollegeOrUniversity"
        name="postGraduationCollegeOrUniversity"
        label="College/ University"
        //placeholder="Post Graduation College/ University"
        value={postGraduationCollegeOrUniversity}
        onChange={handleChange}
        errorMessage={getCommonErrorMessage(
          postGraduationCollegeOrUniversity,
          "College/ University name",
          false
        )}
        // eslint-disable-next-line no-useless-escape
        pattern={"[a-z|A-Z]{1}[a-z|A-Z|.]{1}(a-z|A-Z| |.)*"}
      />
      <FormGroupInput
        min={minYearOfCompletion}
        max={maxYearOfCompletion}
        id="postGraduationYear"
        name="postGraduationYear"
        label="Year of Completion"
        //placeholder="Year of Completion (e.g. 2014)"
        value={postGraduationYear}
        onChange={handleChange}
        inputRef={yearOfCompletionRef}
        errorMessage={getYearOfCompletionErrorMessage(
          yearOfCompletionRef,
          postGraduationYear,
          false
        )}
        pattern={"[0-9]{4}"}
      />
      {Number(postGraduationStream) === -1 && (
        <FormGroupInput style={{ display: "none" }} />
      )}
    </NestedFieldSet>
  );
};

PostGraduation.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handlePostGradStreamChange: PropTypes.func.isRequired,
  postGraduationStreams: PropTypes.array.isRequired,
  postGraduationStream: PropTypes.string.isRequired,
  postGraduationScore: PropTypes.string.isRequired,
  postGraduationCollegeOrUniversity: PropTypes.string.isRequired,
  postGraduationYear: PropTypes.string.isRequired,
};

export { PostGraduation };
